import { styled } from "@mui/material/styles";
import TableRow, { tableRowClasses } from "@mui/material/TableRow";
import { tableCellClasses } from "@mui/material/TableCell";

// Row actions (".hide_action", e.g. copy / delete) show on hover. Hidden,
// they stay in the page (visually hidden, not display: none), so keyboard and
// screen reader users can still reach them: focusing one shows them.
const hiddenAction = {
  position: "absolute",
  width: 1,
  height: 1,
  margin: "-1px",
  padding: 0,
  border: 0,
  overflow: "hidden",
  clipPath: "inset(50%)",
  whiteSpace: "nowrap",
};
const shownAction = {
  position: "static",
  width: "auto",
  height: "auto",
  margin: 0,
  overflow: "visible",
  clipPath: "none",
  whiteSpace: "normal",
  display: "flex",
};

const StyledTableRow = styled(TableRow)(({ theme, hover }) => {
  return {
    [`&.${tableRowClasses.root}`]: {
      border: 0,
      cursor: "pointer",
      position: "relative",
      zIndex: 1,
      backgroundColor: theme.palette.common.white,
      "& .hide_action": hiddenAction,
      "&:focus-within .hide_action": shownAction,
      [`&:last-child .${tableCellClasses.body}`]: {
        borderBottom: 0,
      },

      ...(hover && {
        "&:hover": {
          backgroundColor: "#F4F4F5",
          [`& .${tableCellClasses.root}`]: {
            backgroundColor: "#F4F4F5",
            "& .hide_action": shownAction,
          },
        },
      }),
      [`& .${tableCellClasses.root}`]: {
        backgroundColor: theme.palette.common.white,
      },
    },
  };
});

export default StyledTableRow;
